// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'responsibleDealer',
                    value: 'Responsible Dealer'
                },
                {
                    key: 'dealerCity',
                    value: 'Dealer City'
                },
                {
                    key: 'customerName',
                    value: 'Customer Name'
                },
                {
                    key: 'deliveryDate',
                    value: 'Delivery Date'
                },
                {
                    key: 'registrationDate',
                    value: 'Registration Date'
                },
                {
                    key: 'invoiceDate',
                    value: 'Invoice Date'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'pin',
                    order: 'DESC',
                    value: 'PIN'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/state/views.js